export const CHANNEL = "hoh-projection";
export const DEFAULT_SETTINGS = { fontScale: 7, align: "center", theme: "dark", showFooter: true, repeatChorus: true };
export const LANG_LABEL = { en: "English", yo: "Yoruba" };

export function buildSlides(hymn, repeatChorus) {
  if (!hymn) return [];
  const verses = hymn.verses || [];
  const choruses = verses.filter((v) => v.kind === "chorus");
  const plain = verses.filter((v) => v.kind !== "chorus");
  if (!repeatChorus || choruses.length !== 1 || !plain.length) return verses;
  return plain.flatMap((v) => [v, choruses[0]]);
}

export function slideLabel(s) {
  if (!s) return "";
  return s.kind === "chorus" ? "Chorus" : `Verse ${s.label}`;
}

export function numberLabel(hymn, denom) {
  if (!hymn) return "";
  const cac = `CAC ${hymn.cac_number}`;
  if (denom && !denom.is_default && hymn.number) return `${denom.code} ${hymn.number} · ${cac}`;
  return cac;
}

export function textToVerses(text) {
  return (text || "").replace(/\r\n?/g, "\n").split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean).map((b) => {
    const m = b.match(/^(chorus|refrain|ègbè|egbe)(?![\p{L}])\s*(?:[:.-]|\t|$)\s*/imu);
    return m ? { kind: "chorus", text: b.slice(m[0].length).trim() } : { kind: "verse", text: b.replace(/^\(?\d{1,2}[).:\s]\s*/, "").trim() };
  }).filter((v) => v.text);
}

export function versesToText(verses) {
  return (verses || []).map((v) => (v.kind === "chorus" ? `Chorus: ${v.text}` : v.text)).join("\n\n");
}

const BLOCKED_KEYS = new Set(["s", "p", "c", "a", "u", "x"]);

export function protectHandlers() {
  const stop = (e) => e.preventDefault();
  const keys = (e) => { if ((e.ctrlKey || e.metaKey) && BLOCKED_KEYS.has(e.key.toLowerCase()) && !["INPUT", "TEXTAREA"].includes(e.target.tagName)) e.preventDefault(); };
  const events = [["copy", stop], ["cut", stop], ["contextmenu", stop], ["dragstart", stop], ["keydown", keys]];
  events.forEach(([n, f]) => document.addEventListener(n, f));
  return () => events.forEach(([n, f]) => document.removeEventListener(n, f));
}
